

import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, letterSpacing: '0.5px' }}>
              ALFA TRANSPORTES
            </div>
            <div className="ml-3 text-sm text-gray-600 hidden md:block">
              Transporte Confiable en Ixtapa-Zihuatanejo
            </div>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('servicios')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Servicios
            </button>
            <button 
              onClick={() => scrollToSection('vehiculos')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Vehículos
            </button>
            <button 
              onClick={() => scrollToSection('destino')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Zihuatanejo
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Contacto
            </button>
            <Button 
              onClick={() => scrollToSection('reserva')}
              size="sm"
              icon={<i className="ri-calendar-line"></i>}
            >
              Reservar Ahora
            </Button>
          </nav>

          <button 
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="text-left text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                Inicio
              </button>
              <button 
                onClick={() => scrollToSection('servicios')}
                className="text-left text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                Servicios
              </button>
              <button 
                onClick={() => scrollToSection('vehiculos')}
                className="text-left text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                Vehículos
              </button>
              <button 
                onClick={() => scrollToSection('destino')}
                className="text-left text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                Zihuatanejo
              </button>
              <button 
                onClick={() => scrollToSection('contacto')}
                className="text-left text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                Contacto
              </button>
              <Button 
                onClick={() => scrollToSection('reserva')}
                size="sm"
                className="self-start"
                icon={<i className="ri-calendar-line"></i>}
              >
                Reservar Ahora
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

